import { useState } from "react";

export default function CaptionedImage({
  src,
  alt = "",
  title = "",
  description = "",
  caption = "",
  focalPoint = "50% 0%",
  className = "",
  imageClassName = "",
  loading = "lazy",
  testId,
}) {
  const [showCaption, setShowCaption] = useState(false);
  const image = (
    <img
      data-testid={testId}
      src={src}
      alt={alt}
      title={title || undefined}
      aria-description={description || undefined}
      loading={loading}
      className={imageClassName}
      style={{ objectPosition: focalPoint }}
    />
  );

  if (!caption) {
    return (
      <>
        {image}
        {description && <span className="sr-only">{description}</span>}
      </>
    );
  }

  return (
    <button
      type="button"
      data-testid={testId ? `${testId}-caption-toggle` : undefined}
      onClick={(event) => {
        event.stopPropagation();
        setShowCaption((value) => !value);
      }}
      className={`relative block overflow-hidden text-left p-0 border-0 bg-transparent ${className}`}
      aria-label={showCaption ? "Hide photo caption" : "Show photo caption"}
    >
      {image}
      {description && <span className="sr-only">{description}</span>}
      {showCaption && (
        <span className="absolute bottom-3 right-3 max-w-[75%] rounded-sm bg-[#1E1A17]/75 backdrop-blur-sm px-3 py-2 text-[11px] sm:text-xs text-[#F4EFEA] font-sans text-right shadow-lg">
          {caption}
        </span>
      )}
    </button>
  );
}
